export default __webpack_public_path__ + "static/attraction-world-7d3771e98ca2f166b7be55a675ee0855.jpg";